import * as React from 'react'

import { cn } from '@/lib/utils'
import { Label } from '@/components/ui/label'

import IconSearch from '@/icons/search.svg'
import IconExclamation from '@/icons/exclamation.svg'
import IconCross from '@/icons/cross.svg'
import { ErrorMessage } from '@/components/custom/form/errorMessage'
import {InputHTMLAttributes} from "react";

const inputClasses = {
    basics: 'peer flex w-full rounded-lg border border-gray-beige-light bg-gray-beige-light px-4 py-3 h-12 text-base transition-colors',
    placeholder: 'placeholder:text-gray-beige-dark placeholder:text-sm',
    file: 'file:border-0 file:bg-transparent file:text-sm file:font-medium',
    hover: '',
    focus:
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-gray-beige-dark focus-visible:bg-white',
    disabled: 'disabled:cursor-not-allowed disabled:opacity-50'
}

type InputProps = {
    className?: string,
    label?: string,
    type?: string,
    errors?: string[],
    icon?: string,
    size?: string,
    itemClasses?: string,
    labelClasses?: string,
    onIconClick?: () => void,
} & Omit<InputHTMLAttributes<HTMLInputElement>, "size">

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, label, type, errors, icon, size, itemClasses, labelClasses, onIconClick, ...props }, ref) => {
    return (
        <div className={cn('form__item relative', itemClasses)}>
            <input
                type={type}
                className={cn(
                    inputClasses['basics'],
                    inputClasses['placeholder'],
                    inputClasses['file'],
                    inputClasses['hover'],
                    inputClasses['focus'],
                    inputClasses['disabled'],
                    size === 'sm' && 'h-10 py-2',
                    errors && 'border-destructive text-destructive',
                    className
                )}
                ref={ref}
                {...props}
            />
            {icon && (<span className={`icon absolute right-5 h-4 w-4 ${size === 'sm' ? 'top-3' : 'top-4'}`}>
                {icon === 'search' && <IconSearch />}
                {icon === 'error' && <IconExclamation className='text-destructive' />}
                {icon === 'cross' && <div onClick={onIconClick}><IconCross /></div>}
            </span>)}
            {label && (
                <Label
                    htmlFor={props.id}
                    className={cn(
                        `invisible absolute -top-[10px] left-3 bg-white px-2 text-xs uppercase tracking-widest peer-focus:visible`,
                        errors && 'border-destructive text-destructive',
                        labelClasses
                    )}
                >
                    {label}
                </Label>
            )}
            {errors && errors.map((err, i) => <ErrorMessage key={i} message={err} />)}
        </div>
    )
})
Input.displayName = 'Input'

export { Input }
